
import React from 'react';
import { GlowEffect, GlowEffectProps } from '@/components/ui/glow-effect';
import { cn } from '@/lib/utils';

export interface GlowCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  glowColors?: string[];
  glowMode?: GlowEffectProps['mode'];
  glowBlur?: GlowEffectProps['blur'];
  glowScale?: number;
  glowDuration?: number;
  showGlowOnHover?: boolean;
  className?: string;
  contentClassName?: string;
}

export function GlowCard({
  children,
  glowColors = ['#c8a87d', '#e6d5b8', '#f9f9f9', '#a68756'],
  glowMode = 'breathe',
  glowBlur = 'soft',
  glowScale = 1.05,
  glowDuration = 6,
  showGlowOnHover = true,
  className,
  contentClassName,
  ...props
}: GlowCardProps) {
  return (
    <div 
      className={cn(
        "relative rounded-xl overflow-hidden bg-white/90 backdrop-blur-sm border border-luxury-200 p-5 shadow-sm transition-all duration-300 hover:shadow-luxury group",
        className
      )} 
      {...props}
    >
      <div className={cn(
        "absolute inset-0 transition-opacity duration-500",
        showGlowOnHover ? "opacity-0 group-hover:opacity-100" : "opacity-100"
      )}>
        <GlowEffect
          colors={glowColors}
          mode={glowMode}
          blur={glowBlur}
          scale={glowScale}
          duration={glowDuration}
        />
      </div>
      
      <div className={cn("relative z-10", contentClassName)}>
        {React.Children.map(children, child => {
          if (React.isValidElement(child) && 
             (child.type === 'h1' || child.type === 'h2' || child.type === 'h3' || 
              child.type === 'h4' || child.type === 'h5' || child.type === 'h6')) {
            return React.cloneElement(child as React.ReactElement<any>, {
              className: cn('text-gold', (child as React.ReactElement<any>).props.className)
            });
          }
          return child;
        })}
      </div>
    </div>
  );
}
